/**
 * AFW Product Cards Enhancement v1.0
 * Adds Part # badge, fitment line, and brand highlight to product cards.
 * Works with Gecko 6.2 Design 6 (product-grid-item6.liquid).
 * Light theme — uses existing site CSS variables.
 *
 * Reads data from DOM attributes already rendered by Liquid:
 *   data-afw-sku  — variant SKU (Part Number)
 *   data-tags     — comma-separated product tags (includes Year_*, Make_*, Model_*)
 */
(function () {
  'use strict';

  /* ---- SVG icons ---- */
  var ICON_CAR = '<svg class="afw-fit-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/></svg>';
  var ICON_CHECK = '<svg class="afw-fit-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>';

  /* ---- Saved vehicle context (from Vehicle Finder / AutoSync localStorage) ---- */
  var savedVehicle = null;
  try {
    /* Try AutoSync "vehicle" key first, then AFW sidebar "afw_vehicle" */
    var raw = localStorage.getItem('vehicle') || localStorage.getItem('afw_vehicle');
    if (raw) {
      var v = JSON.parse(raw);
      /* AutoSync stores: { rawApiResponse: {...}, ... } with year/make/model at top or nested */
      var yr = v.year || (v.rawApiResponse && v.rawApiResponse.Year);
      var mk = v.make || (v.rawApiResponse && v.rawApiResponse.Make);
      var ml = v.model || (v.rawApiResponse && v.rawApiResponse.Model);
      if (!mk) {
        /* Check tcwlw format: { data: { year, make, model } } */
        if (v.data && v.data.make) { yr = v.data.year; mk = v.data.make; ml = v.data.model; }
      }
      if (mk) {
        savedVehicle = {
          year: String(yr || '').toLowerCase(),
          make: String(mk || '').toLowerCase(),
          model: String(ml || '').toLowerCase()
        };
      }
    }
  } catch (e) { /* ignore */ }

  /* ---- Tag parser: extract fitment from data-tags ---- */
  function parseFitment(tagsStr) {
    if (!tagsStr) return null;

    var tags = tagsStr.split(',');
    var years = [];
    var makes = [];
    var models = [];

    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i].trim();
      /* Support both formats: "Year_2019" (T14 import) and "year:2019" (MRY/SEO tagger) */
      if (tag.indexOf('Year_') === 0) {
        var y = tag.substring(5);
        if (y && !isNaN(y)) years.push(parseInt(y, 10));
      } else if (tag.indexOf('year:') === 0) {
        var y2 = tag.substring(5);
        if (y2 && !isNaN(y2)) years.push(parseInt(y2, 10));
      } else if (tag.indexOf('Make_') === 0) {
        var m = tag.substring(5);
        if (m) makes.push(m);
      } else if (tag.indexOf('make:') === 0) {
        var m2 = tag.substring(5);
        if (m2) makes.push(m2);
      } else if (tag.indexOf('Model_') === 0) {
        var md = tag.substring(6);
        if (md) models.push(md);
      } else if (tag.indexOf('model:') === 0) {
        var md2 = tag.substring(6);
        if (md2) models.push(md2);
      }
    }

    if (makes.length === 0 && models.length === 0 && years.length === 0) return null;

    /* Build year range string */
    var yearStr = '';
    if (years.length > 0) {
      years.sort(function (a, b) { return a - b; });
      var minY = years[0];
      var maxY = years[years.length - 1];
      yearStr = minY === maxY ? String(minY) : minY + '-' + maxY;
    }

    /* Deduplicate makes/models */
    makes = unique(makes);
    models = unique(models);

    /* Build fitment string */
    var parts = [];
    if (yearStr) parts.push(yearStr);
    if (makes.length > 0) parts.push(makes.length <= 2 ? makes.join(', ') : makes[0] + ' +' + (makes.length - 1));
    if (models.length > 0) parts.push(models.length <= 2 ? models.join(', ') : models[0] + ' +' + (models.length - 1));

    if (parts.length === 0) return null;

    /* Check vehicle match */
    var isMatch = false;
    if (savedVehicle) {
      var makeMatch = makes.length === 0 || makes.some(function (mk) {
        return mk.toLowerCase() === savedVehicle.make;
      });
      var modelMatch = models.length === 0 || models.some(function (md) {
        return md.toLowerCase() === savedVehicle.model;
      });
      var yearMatch = years.length === 0 || (savedVehicle.year && years.indexOf(parseInt(savedVehicle.year, 10)) !== -1);
      isMatch = makeMatch && modelMatch && yearMatch && (makes.length > 0 || models.length > 0);
    }

    return {
      text: 'Fits: ' + parts.join(' '),
      isMatch: isMatch
    };
  }

  function unique(arr) {
    var seen = {};
    var result = [];
    for (var i = 0; i < arr.length; i++) {
      var key = arr[i].toLowerCase();
      if (!seen[key]) {
        seen[key] = true;
        result.push(arr[i]);
      }
    }
    return result;
  }

  /* ---- Enhance a single product card ---- */
  function enhanceCard(card) {
    if (card.getAttribute('data-afw-enhanced')) return;
    card.setAttribute('data-afw-enhanced', '1');

    var sku = card.getAttribute('data-afw-sku');
    var tagsStr = card.getAttribute('data-tags');

    /* 1. Part # badge — inject into .t4s-product-inner (image area) */
    if (sku && sku.length > 0) {
      var imgArea = card.querySelector('.t4s-product-inner');
      if (imgArea) {
        var badge = document.createElement('div');
        badge.className = 'afw-card-sku';
        badge.innerHTML = '<span class="afw-sku-label">Part#</span> ' + escapeHtml(sku);
        imgArea.appendChild(badge);
      }
    }

    /* 2. KC Customs-style info block — Brand + Part Number + Fitment below title */
    var infoInner = card.querySelector('.t4s-product-info__inner');
    var priceEl = card.querySelector('.t4s-product-price');
    if (infoInner && priceEl) {
      var infoBlock = document.createElement('div');
      infoBlock.className = 'afw-card-info-block';

      /* Brand line (already shown by vendor, but we add Part # line) */
      var vendor = card.querySelector('.t4s-product-vendor');
      var vendorText = vendor ? vendor.textContent.trim() : '';

      /* Part Number line */
      if (sku && sku.length > 0) {
        var partLine = document.createElement('div');
        partLine.className = 'afw-card-part-line';
        partLine.innerHTML = '<span class="afw-info-label">Part Number:</span> <span class="afw-info-value">' + escapeHtml(sku) + '</span>';
        infoBlock.appendChild(partLine);
      }

      /* Fitment line */
      var fitment = parseFitment(tagsStr);
      if (fitment) {
        var fitLine = document.createElement('div');
        fitLine.className = 'afw-card-fitment' + (fitment.isMatch ? ' afw-fit-match' : '');
        fitLine.innerHTML = (fitment.isMatch ? ICON_CHECK : ICON_CAR) +
          '<span class="afw-fit-text">' + escapeHtml(fitment.text) + '</span>';
        infoBlock.appendChild(fitLine);
      }

      /* Insert after price */
      priceEl.parentNode.insertBefore(infoBlock, priceEl.nextSibling);
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* ---- Process all cards on page ---- */
  function enhanceAll() {
    var cards = document.querySelectorAll('.t4s-pr-style6:not([data-afw-enhanced])');
    if (cards.length === 0) return;

    /* Process in batches to avoid jank */
    var BATCH = 50;
    var idx = 0;

    function processBatch() {
      var end = Math.min(idx + BATCH, cards.length);
      for (var i = idx; i < end; i++) {
        enhanceCard(cards[i]);
      }
      idx = end;
      if (idx < cards.length) {
        requestAnimationFrame(processBatch);
      }
    }

    requestAnimationFrame(processBatch);
  }

  /* ---- Init ---- */
  function init() {
    enhanceAll();

    /* Watch for "Load More" / infinite scroll injecting new cards */
    var grid = document.querySelector('.t4s-products, .t4s-row-prs, #t4s-col-right, .t4s-collection-content, #MainContent');
    if (grid) {
      var observer = new MutationObserver(function (mutations) {
        var hasNewCards = false;
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length > 0) {
            hasNewCards = true;
            break;
          }
        }
        if (hasNewCards) {
          /* Small delay to let theme JS finish initializing new cards */
          setTimeout(enhanceAll, 100);
        }
      });
      observer.observe(grid, { childList: true, subtree: true });
    }
  }

  /* Fire on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Also re-run after a delay in case of lazy loading */
  setTimeout(function () { enhanceAll(); }, 2000);
})();
